import React, { useState, useContext } from "react";
import { Pagination } from "flowbite-react";
import Context from "../../Context/Context";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const PaginationComponent = ({
  data,
  currentPage,
  onPageChange,
  itemsPerPage = 6,
  showIcons = true,
  hideResultsText,
  totalPages: totalPagesParam,
}) => {
  const Ctx = useContext(Context);
  const isDarkMode = Ctx.isDarkMode ?? true;
  
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const totalPages = totalPagesParam || Math.ceil(data?.length / itemsPerPage) || 1;

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between mt-6 px-2 gap-4">
      {!hideResultsText && (
        <div className={`text-xs max850:hidden animate-fadeIn ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
          Showing <span className="font-medium">{startIndex + 1}</span> to{" "}
          <span className="font-medium">{Math.min(endIndex, data?.length || 0)}</span>{" "}
          of <span className="font-medium">{data?.length || 0}</span> results
        </div>
      )}
      
      {/* Custom Pagination */}
      <div className="flex items-center gap-2">
        {/* Previous Button */}
        <button
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
          className={`flex items-center justify-center w-8 h-8 rounded transition-all duration-200 ${
            currentPage === 1
              ? isDarkMode 
                ? 'bg-[#1a1a1a] text-gray-500 cursor-not-allowed' 
                : 'bg-gray-100 text-gray-400 cursor-not-allowed'
              : isDarkMode
                ? 'bg-[#1a1a1a] text-gray-300 hover:bg-[#2a2a2a]'
                : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-300'
          }`}
        >
          <FaChevronLeft size={14} />
        </button>

        {/* Page Numbers */}
        <div className="flex items-center gap-1">
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => {
            // Show first page, last page, current page and adjacent pages
            if (
              page === 1 ||
              page === totalPages ||
              (page >= currentPage - 1 && page <= currentPage + 1)
            ) {
              return (
                <button
                  key={page}
                  onClick={() => onPageChange(page)}
                  className={`w-8 h-8 rounded transition-all duration-200 text-xs font-semibold flex items-center justify-center ${
                    currentPage === page
                      ? 'bg-[#FDCF08] text-black'
                      : isDarkMode
                        ? 'bg-[#1a1a1a] text-gray-300 hover:bg-[#2a2a2a]'
                        : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-300'
                  }`}
                >
                  {page}
                </button>
              );
            } else if (
              (page === currentPage - 2 && currentPage > 3) ||
              (page === currentPage + 2 && currentPage < totalPages - 2)
            ) {
              return (
                <span
                  key={page}
                  className={`w-8 h-8 flex items-center justify-center text-xs ${
                    isDarkMode ? 'text-gray-500' : 'text-gray-400'
                  }`}
                >
                  ...
                </span>
              );
            }
            return null;
          })}
        </div>

        {/* Next Button */}
        <button
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages}
          className={`flex items-center justify-center w-8 h-8 rounded transition-all duration-200 ${
            currentPage === totalPages
              ? isDarkMode 
                ? 'bg-[#1a1a1a] text-gray-500 cursor-not-allowed' 
                : 'bg-gray-100 text-gray-400 cursor-not-allowed'
              : isDarkMode
                ? 'bg-[#1a1a1a] text-gray-300 hover:bg-[#2a2a2a]'
                : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-300'
          }`}
        >
          <FaChevronRight size={14} />
        </button>
      </div>
    </div>
  );
};

export default PaginationComponent;
